module.exports = __webpack_public_path__ + "static/img/jijubaofeishenqing.7c589e52.png";